import { AppDispatch, selectAuth, useAppSelector } from "@redux";
import { PATH_LOGIN } from "@routes";
import _ from "lodash";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { LoadingStage } from "src/Interfaces/shared";
import { initializeAccountDetail, loadAccountDetail, selectAccount } from "@redux";
import styled from "styled-components";
import { ErrorToast } from "src/Components/toasts/ErrorToast";

// Define the ProtectedRoute component
const ProtectedRoute = ({ redirectPath = PATH_LOGIN }) => {
    const dispatch = useDispatch<AppDispatch>();
    const { jwt } = useAppSelector(selectAuth);
    const { account, loadingStage } = useAppSelector(selectAccount);
    const [shouldRedirect, setShouldRedirect] = useState<boolean>(_.isNil(account) || _.isNil(jwt));
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        if (shouldRedirect) return;
        // fire account detail
        switch (loadingStage) {
            case LoadingStage.NOT_INITIALIZED:
                if (_.isNil(jwt)) {
                    dispatch(initializeAccountDetail());
                }
                break;
            case LoadingStage.INITIALIZE_COMPLETE:
                dispatch(loadAccountDetail());
                break;
            default:
                break;
        }
    }, []);

    useEffect(() => {
        switch (loadingStage) {
            case LoadingStage.INITIALIZE_FAILURE:
                setShouldRedirect(true);
                break;
            default:
                break;
        }
    }, [loadingStage]);

    useEffect(() => {
        if (shouldRedirect) {
            ErrorToast({ Message: "Please login first" });
            const returnPath = encodeURIComponent(location.pathname + location.search);
            navigate(`${redirectPath}?returnPath=${returnPath}`);
        }
    }, [shouldRedirect, location.pathname, location.search, navigate, redirectPath]);

    if (shouldRedirect) {
        return null;
    }

    return (
        <Container>
            {/* Render child routes */}
            <Outlet />
        </Container>
    );
};

const Container = styled.div`
    height: 100%;
`;

export default ProtectedRoute;
